<dynamic-material-form
  #form
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange($event)"
  data-test="gsm-geschaedigte-person_form"
>
</dynamic-material-form>
